
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects",
      function () {
        return require("private-next-pages/projects/index.js");
      }
    ]);
  